import { Skeleton } from '@mui/material';
import React from 'react';

const SkeletonWrapper = ({ isLoading, component, variant, animation, fullWidth, skeletonProps, children }) => {
  return (
    <>
      {isLoading ? (
        <Skeleton
          animation={animation ? animation : 'wave'}
          variant={variant ? variant : 'text'}
          width={fullWidth ? '100%' : ''}
          {...skeletonProps}>
          {children || component}
        </Skeleton>
      ) : (
        children || component
      )}
    </>
  );
};

export default SkeletonWrapper;
